/**
 * VideoPlayer Module
 */
import * as VideoPlayerActions from './actions/videoActions'
import VideoPlayerStates from './constants/videoPlayStates'
import VideoPlayerReducer from './reducers/videoReducer'
import VideoPlayerSelectors from './selectors/videoSelectors'
import VideoPlayerUI from './components/VideoPlayerUI'

export { VideoPlayerActions, VideoPlayerStates, VideoPlayerReducer, VideoPlayerSelectors, VideoPlayerUI }
